import { Enums } from "@/helpers/enums";
import { Links } from "@/helpers/links";
import { Ajax, MethodType, Web } from "@/helpers/web";
import { appData, C, D, J, Rnd, Text } from "@/helpers/global";

import store from "@/store";
import router from '@/router';
import { PersonToken } from "@/services/requests/person_token";
import { PersonRefreshTokenLogin } from "@/services/requests/person_refreshToken_login";
import { StorePerson } from "@/store/constants";

let isRefreshing = false;
let pendingRequests = [];

export const PersonService = {
    IsLogin(callback) {
        if (!store.getters[StorePerson.isLogin]) {
            this.Logout();
            return false;
        }
        if (callback) {
            callback();
        }
        return true;
    },
    async GetTokenIsLogin(callback) {
        const token = await PersonService.GetAccessRefreshToken(false);
        if (token) {
            if (callback) { await callback(); }
            return true;
        }
        else {
            this.Logout();
            return false;
        }
    },
    async GetAccessRefreshToken(escapeToken) {
        if (C.Bool(escapeToken)) {
            return null;
        }
        let token = new PersonToken(store.state.person?.token);
        if (!Text.IsEmpty(token?.accessToken)) {
            const j = appData.fn.parseJwt(token.accessToken)
            if (j.exp) {
                const now = Date.now();
                if (j.exp >= Math.floor(now / 1000) + 60) {
                    return token.accessToken;
                }
            }
        }

        const refreshToken = C.Str(token?.refreshToken);
        if (Text.IsEmpty(refreshToken)) {
            return null;
        }
        if (!isRefreshing) {
            isRefreshing = true;
            try {
                const newAccessToken = await new Promise((resolve, reject) => {
                    PersonService.RefreshTokenLogin(new PersonRefreshTokenLogin(refreshToken), (status) => {
                        if (status) {
                            token = new PersonToken(store.state.person.token);
                            resolve(C.Str(token?.accessToken));
                        }
                        else {
                            reject("Failed to refresh token");
                        }
                    });
                });
                pendingRequests.forEach(callback => callback(newAccessToken));
                pendingRequests = [];
                return newAccessToken;
            }
            catch (ex) {
                console.log(ex);
                return null;
            }
            finally {
                isRefreshing = false;
            }
        }
        else {
            // Yenileme işlemi devam ederken, istekleri beklet
            return new Promise((resolve) => {
                pendingRequests.push(resolve);
            });
        }
    },
    Logout(isAll) {
        store.dispatch(StorePerson.logout, C.Bool(isAll));
        let returnUrl = "";
        if (!isAll) {
            const url = new URL(window.location.href);
            returnUrl = `?returnUrl=${encodeURIComponent(`${url.pathname}${url.search}`)}`;
        }
        //Web.Redirect(Links.Url(Links.Login) + returnUrl);
        setTimeout(() => {
            router.push(Links.Url(Links.Login) + returnUrl); // Router ile yönlendirme yapın
        }, 100);
    },
    LoginRedirect(returnUrl) {
        setTimeout(function () {
            if (returnUrl) {
                Web.Redirect(decodeURIComponent(returnUrl));
            }
            else {
                Web.Redirect(Links.Url(Links.Dashboard));
            }
        }, 100);
    },
    Login(j, isRemember, callback, wait) {
        Ajax.Api(MethodType.Post, Enums.SERVICE.PERSON + "/login", j, wait, null, true).then((data) => {
            store.dispatch(StorePerson.login, data);
            callback(data);
        });
    },
    RefreshTokenLogin(j, callback) {
        Ajax.Api(MethodType.Post, Enums.SERVICE.PERSON + "/refresh-token-login", j, null, null, true).then((data) => {
            store.dispatch(StorePerson.login, data);
            callback(true, data);
        }).catch((err) => {
            if (!err) { err = {}; }
            callback(false, C.Str(C.Str(err.statusText, err.message), "There was a problem with the server! Please try again"));
        }, false);
    },
    ForgotPassword(j, callback, wait) {
        Ajax.Api(MethodType.Post, Enums.SERVICE.PERSON + "/password-reset", j, wait, null, true).then((data) => {
            callback(data);
        });
    },
    VerifyResetToken(j, callback) {
        Ajax.Api(MethodType.Post, Enums.SERVICE.PERSON + "/verify-reset-token", j, null, null, true).then((data) => {
            callback(data);
        });
    },
    ResetPassword(j, callback, wait) {
        Ajax.Api(MethodType.Post, Enums.SERVICE.PERSON + "/reset-token-password-change", j, wait, null, true).then((data) => {
            callback(data);
        });
    },
    Me(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.PERSON + "/me", null, wait).then((data) => {
            callback(data);
        });
    },
    PasswordProfileChange(j, callback, wait) {
        Ajax.Api(MethodType.Put, Enums.SERVICE.PERSON + "/password-profile-change", j, wait).then((data) => {
            if (C.Str(data) != "") {
                const person = store.getters[StorePerson.get];
                person.profile = data;
                store.dispatch(StorePerson.set, person);
            }
            callback(data);
        });
    },
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.PERSON, null, wait).then((data) => {
            callback(data);
        });
    },
    ById(id, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.PERSON + "/" + id, null, wait).then((data) => {
            callback(data);
        });
    },
    Save(j, callback, wait) {
        Ajax.Api((j.id > 0 ? MethodType.Put : MethodType.Post), Enums.SERVICE.PERSON, j, wait).then((data) => {
            callback(data);
        });
    },
    Delete(id, callback) {
        const j = {};
        Ajax.Api(MethodType.Delete, Enums.SERVICE.PERSON + "/" + id, j).then((data) => {
            callback(data);
        });
    },
};